import React, { useState, useEffect } from 'react';
import Button from "@mui/material/Button";
import CameraComponent from './CameraComponentV2';
import RegisterComponent from './RegisterComponent';
import CompletedComponent from './CompletedComponent';
import { GetCaseStatus, startProgress } from './API';
import CircularProgress from '@mui/material/CircularProgress';
 


// console.log(window.location)
const windowUrl = window.location.search;
// console.log(windowUrl)
const params = new URLSearchParams(windowUrl);
// console.log(params)
const encodedcID = params.get('_c')
// console.log(encodedcID) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var caseID = atob(encodedcID);
  // console.log(caseID); // Outputs: 138


const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
let loadingSize = 40;
    if(windowWidth > windowHeight){ 
        loadingSize = windowHeight*0.75; 
    } else{ 
        loadingSize = windowWidth*0.75; 
    }

function App() {
  const [implemented, setImplemented] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getData();
    }, []);

  const handleRedirect = () => {
      console.log("handleRedirect");
      // this.setState({language: langValue});

        let sendData = new FormData();
        // console.log("byPassData",byPassData);
        sendData.append('caseID', caseID);

        setLoading(true);
        startProgress(sendData).then(response => {
            console.log("response", response);
            setLoading(false);
            if (response && response.status === 200) {
                console.log("response.data", response.data);
                console.log("response.data.success", response.data.success);
                if(response.data.success == true){
                  setImplemented(true);
                }
            }else if (response && response.data){
                console.log("API response error ["+ response.status + "]", response.data.message);
            }else{
                console.log("API response error", response);
            }
        })

      // setImplemented(true);
  }

  const getData = () => {
      if(encodedcID){

        let sendData = new FormData();
        // console.log("byPassData",byPassData);
        sendData.append('caseID', caseID);

        GetCaseStatus(sendData).then(response => {
            // console.log("response", response);
            if (response && response.status === 200 && response.data.success) {
              setLoading(false);
              // console.log("response.data", response.data);
              // console.log("response.data.sttcase", response.data.sttcase);
              if((response.data.sttcase >= 33 && response.data.sttcase < 38) || response.data.sttcase == 55){
                setImplemented(true);
              }else if(response.data.sttcase >= 38 && response.data.sttcase != 55){
                setCompleted(true);
              }
            }else if (response && response.data){
              console.log("API error ["+ response.status + "] : ", response.data.message);
            }else{
              console.log("API error: ", response);
              alert(response);
            }
        })
      }else{
        alert("parameter ไม่ถูกต้อง");
        return;
      }
  }

  return (
    <div style={{maxWidth:'1000px',margin:'0 auto'}}>
      {
        loading ? 
          <div className="d-flex flex-column align-items-center pt-3 container">
            <CircularProgress size={loadingSize} />
          </div>
        : 
          implemented? <RegisterComponent />
          : completed? <CompletedComponent />
          : <>
            <div style={{maxWidth:'600px', margin:'0 auto', textAlign: 'center', paddingTop: '40vh'}}>
              <h1 style={{color:'#0d6efd'}}>
                การตรวจสภาพรถด้วยตนเอง
              </h1>
              <p>กรุณาถ่ายรูปรถตามตัวอย่างด้านล่างนี้ แล้วอัปโหลดรูปภาพผ่าน</p>

                <Button onClick={handleRedirect} sx={{ mt: 3, ml: 1 }}>
                    <p>รับทราบ</p>
                </Button>
            </div>
          </>
      }

      {/*
      
        <CameraComponent />
      */}
    </div>
  );
}
 
export default App;